<template>
  <Content>
    <template #body>
      <Form
        :scheme="scheme"
        :method-fetch-data="methods.fetchData"
        :method-update-data="methods.updateData"
        :method-create-data="methods.createData"
        :method-update-scheme="methods.updateScheme"
        :send-all-form="true"
      />
    </template>
  </Content>
</template>

<script>
import Content from "@/layout/Content";
import Form from "@/components/Form";

import addCollectionsToScheme from "@/utils/addCollectionsToScheme";
import {
  postRegions as createData,
  getRegionId,
  putRegion as updateData,
} from "@/api/regions";
import { Regions as defaultScheme } from "@/api/schemes/regions";

const updateScheme = async (scheme) => {
  try {
    scheme = await addCollectionsToScheme(scheme);
  } catch (err) {
    console.log(err);
  }
  return scheme;
};

const midFunc = async (id, params) => {
  const data = await getRegionId(id, params);
  const region = {
    ...data,
    macroregion_id: data.macroregion?.id,
  };
  return region;
};

export default {
  components: {
    Content,
    Form,
  },
  data() {
    return {
      scheme: defaultScheme,
      methods: {
        createData,
        fetchData: midFunc,
        updateData,
        updateScheme,
      },
    };
  },
};
</script>
